export class UnknownThreadColorError extends Error {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "message", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "Unknown thread color"
    });
  }
}